import React from "react"
import Link from "../basics/Link"
import cx from "classnames"

import RightArrow from "../../assets/icons/arrow-midnight-5-right.svg"

const Breadcrumb = ({ data, negative = false }) => <div className="flex items-center gap-1 text-small">
  {Object.keys(data).map((label, index) => {
    const last = index === Object.keys(data).length - 1
    const textColor = cx({
      "text-midnight-30": !negative && !last,
      "text-midnight-10": !negative && last,
      "text-midnight-50": negative && !last,
      "text-white": negative && last
    })

    return <>
      {data[label] ? <Link
        to={data[label]}
        className={cx("whitespace-nowrap", textColor)}
        key={`breadcrumb-label-${index}`}
      >
        {label}
      </Link> : <span className={`${textColor} truncate max-w-[260px]`} key={`breadcrumb-label-${index}`}>{label}</span>}
      {!last && <RightArrow className="h-2 w-2" key={`breadcrumb-arrow-${index}`} />}
    </>
  })}
</div>

export default Breadcrumb